import { initBannerGlide } from "./Partials/BannerGlide";

initBannerGlide(1);